import React, { useState, useRef, useEffect } from "react";
import Collapsible from "../collapsible";

  const FAQList = () => {
    const [lastIndex, setLastIndex] = useState(-1);
    const contentRef = useRef();

    const toggle = (value) => {
      if (value !== lastIndex) {
        setLastIndex(value);
     }      
    };

    const list = [
      {
        q: "What is Rumba?",
        a: (
          <p>
            <a
              href="https://play.google.com/store/apps/details?id=com.doublethefun.rumba"
              target="_blank"
              rel="noopener noreferrer"
            >
              Rumba - Ballroom Dancing
            </a>{" "} is a step by step guide to the American Style Rumba. 
            Learn all the steps in the American style rumba through this step by step guide. 
            Practice and master the rumba steps as you play the Name That Step game. 
            You will become an expert before you know it. &#x1F483;
          </p>
        ),
      },
      {
        q: "What style of Rumba does this app cover?",
        a: (
          <p>
            All 10 steps in the American Style Rumba.
          </p>
        ),
      },
      {
        q: "How do you switch between the steps for male and female?",
        a: (
          <p>
            Click the gender/shoe switch on the screen that lists all the steps.
            <img
              src="/images/rumba/GenderSwitch.jpg"
              alt="Gender Switch"
              className="center"/>
          </p>
        ),
      },
      {
        q: "How to show both male and female steps?",
        a: (
          <p>
            Click the shoe button on the screen that plays the dance steps.
          </p>
        ),
      },
      {
        q: "How to watch a demo of the steps?",
        a: (
          <p>
            Click the Demo button on the screen that plays the dance steps.
          </p>
        ),
      },
      {
        q: "How to get a higher score in the Name That Step game?",
        a: (
          <p>
            Practice Practice Practice!!!
          </p>
        ),
      }
    ];
    
    return list.map((question, index) => (
      <Collapsible
        ref={contentRef}
        toggle={toggle}
        title={question.q}
        index={index}
        key={index}
        show={lastIndex === index}
        headerClassName="faqHeader"
        contentClassName="faqContent"
        headerColor="color-blue"
      >
        {question.a}
      </Collapsible>
    ));
  }

  export default FAQList;
